import { Divider, Skeleton } from '@frontend-workspace/react-shared-lib';

export function CompanyRequestsGridSkeleton() {
  return (<>
    <div className="d-flex flex-wrap">
      <Skeleton className="me-3" animation="wave" width={150} height={50} />
      <Skeleton animation="wave" width={150} height={50} />
    </div>
    <Divider className="mb-1" />
    <div className='d-flex justify-content-end'>
      <Skeleton animation="wave" width={150} height={50} />
    </div>
    <Skeleton variant="rectangular" animation="wave" width='100%' height={650} />
  </>);
}

export default CompanyRequestsGridSkeleton;
